import { UserService } from 'api/generated';
import { ID } from 'components/table/types';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useEmployeePersonalHistoryDetailsKey = 'EmployeePersonalHistoryDetails';

export const fetchEmployeePersonalHistoryDetails = async (id: ID) => {
  const data = await UserService.getUsersPersonalHistoryDetails(id as number);
  return data;
};

export const useEmployeePersonalHistoryDetailsQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  {
    id
  }: {
    id: ID;
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchEmployeePersonalHistoryDetails>>,
      QueryError,
      Awaited<ReturnType<typeof fetchEmployeePersonalHistoryDetails>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [useEmployeePersonalHistoryDetailsKey, ...(queryKey ?? [{ id }])],
    () => fetchEmployeePersonalHistoryDetails(id),
    options
  );
